var _a;
import { __decorate, __metadata } from "tslib";
import { inject, injectable } from 'inversify';
import { CopyCustomFieldRepository } from '../repositories/copy-custom-field-repository.interface';
let CopyCustomFieldServiceImpl = class CopyCustomFieldServiceImpl {
    copy(options) {
        return this._copyCustomFieldRepository.copyCustomField(options);
    }
};
__decorate([
    inject(CopyCustomFieldRepository),
    __metadata("design:type", typeof (_a = typeof CopyCustomFieldRepository !== "undefined" && CopyCustomFieldRepository) === "function" ? _a : Object)
], CopyCustomFieldServiceImpl.prototype, "_copyCustomFieldRepository", void 0);
CopyCustomFieldServiceImpl = __decorate([
    injectable()
], CopyCustomFieldServiceImpl);
export { CopyCustomFieldServiceImpl };
